import React, { useState } from "react";
import classNames from "classnames";
import { Form, Field } from "react-final-form";

import validate from "./SearchFieldValidations";

const SearchField = ({
  isDisplay = true,
  onSubmit = () => {},
  toggleDisplay = () => {},
  children,
}) => {
  const [isAdvanceSearch, setIsAdvanceSearch] = useState(false);

  return (
    <div id="search-field">
      <div className={classNames({ hidden: !isDisplay })}>
        <Form
          onSubmit={onSubmit}
          validate={validate}
          className="form__search"
          render={({ handleSubmit, form }) => (
            <form onSubmit={handleSubmit}>
              <Field name="search">
                {({ input, meta }) => (
                  <div className="search-field">
                    <div>
                      <input {...input} type="text" placeholder="Buscar" />
                      {meta.error && meta.touched && (
                        <div className="p-1 text-danger">{meta.error}</div>
                      )}
                    </div>
                    <button>
                      <i className="fas fa-search" />
                    </button>
                  </div>
                )}
              </Field>

              <Field name="advance_search" type="checkbox">
                {({ input }) => (
                  <div className="p-3 mb-2 mt-2 bg-light text-dark">
                    <input
                      {...input}
                      onClick={() => setIsAdvanceSearch(!isAdvanceSearch)}
                    />{" "}
                    Búsqueda avanzada
                  </div>
                )}
              </Field>

              {isAdvanceSearch && (
                <div className="form-inline mb-3">
                  <Field
                    name="filters.tags__tag"
                    parse={(value) =>
                      value && value.replace(/ /g, ",").split(",")
                    }
                  >
                    {({ input }) => (
                      <div className="mr-sm-3 bg-light p-2 rounded-lg">
                        <label>Tags</label>
                        <input {...input} type="text" />
                      </div>
                    )}
                  </Field>

                  <Field name="filters.category__slug">
                    {({ input }) => (
                      <div className="mr-sm-2 bg-light p-2 rounded-lg">
                        <label>Categoría</label>
                        <select {...input}>
                          <option>---</option>
                          <option value="capital">Capital</option>
                          <option value="cartones">Cartones</option>
                          <option value="ciencia-y-tecnologia">
                            Ciencia y Tecnología
                          </option>
                          <option value="cultura">Cultura</option>
                          <option value="deportes">Deportes</option>
                          <option value="economia">Economía</option>
                          <option value="estados">Estados</option>
                          <option value="mundo">Mundo</option>
                          <option value="opinion">Opinión</option>
                          <option value="politica">Política</option>
                          <option value="sociedad">Sociedad</option>
                          <option value="sin-fronteras">
                            La Jornada Sin Fronteras
                          </option>
                          <option value="sociedad-y-justicia">
                            Sociedad y Justicia
                          </option>
                        </select>
                      </div>
                    )}
                  </Field>

                  <Field name="filters.date">
                    {({ input, meta }) => (
                      <div className="bg-light p-2 rounded-lg">
                        <label>Desde la fecha</label>
                        <input {...input} type="date" />
                        {meta.error && meta.touched && (
                          <div className="p-1 text-danger">{meta.error}</div>
                        )}
                      </div>
                    )}
                  </Field>
                </div>
              )}
            </form>
          )}
        />
      </div>

      <div className={classNames("toggle-area", { hidden: isDisplay })}>
        <button className="button-again" onClick={toggleDisplay}>
          Búsqueda
          <i className="fas fa-angle-down" />
        </button>
      </div>
      {children}
    </div>
  );
};

export default SearchField;
